import { ModelBase } from 'store/model-base';

export class PlanSwitchOrderReview extends ModelBase {
    public static storeName: string = 'planSwitchOrderReview';
    
    public analyticsData: PlanChangeAnalyticsPayload;
    public orderSummary: LevelMoveOrderSummary;
    public unlimitedPlanGroup: LevelMoveDataPlanGroup;
    public monthlyUnlimitedPlanGroup: LevelMoveDataPlanGroup;
    public byTheGigPlanGroup: LevelMoveDataPlanGroup;
    public monthlyByTheGigPlanGroup: LevelMoveDataPlanGroup;
    public tabletPlanGroup: LevelMoveDataPlanGroup;
    public monthlyTabletPlanGroup: LevelMoveDataPlanGroup;
    public smartWatchPlanGroup: LevelMoveDataPlanGroup;
    public monthlySmartWatchPlanGroup: LevelMoveDataPlanGroup;


    public static create<T extends ModelBase>(data: ApiResponse): T {
        data.orderSummary = {
            pageHeader: data.pageHeader,
            containerHeader: data.containerHeader,
            containerSubHeader: data.containerSubHeader,
            planGroups: data.planGroups,
            summaries: data.summaries,
            ctas: data.ctas
        };
        if (data.orderSummary.summaries.estimatedNextBill.myData.planGroups && data.orderSummary.summaries.estimatedNextBill.myData.planGroups.length > 0) {
            data.unlimitedPlanGroup = data.orderSummary.summaries.estimatedNextBill.myData.planGroups.find(
                (group: LevelMoveDataPlanGroup) => group.planType === 'UNLIMITED'
            );
        }

        if (data.orderSummary.summaries.estimatedMonthlyBill.myData.planGroups && data.orderSummary.summaries.estimatedMonthlyBill.myData.planGroups.length > 0) {
            data.monthlyUnlimitedPlanGroup = data.orderSummary.summaries.estimatedMonthlyBill.myData.planGroups.find(
                (group: LevelMoveDataPlanGroup) => group.planType === 'UNLIMITED'
            );
        }

        if (data.orderSummary.summaries.estimatedNextBill.myData.planGroups && data.orderSummary.summaries.estimatedNextBill.myData.planGroups.length > 0) {
            data.byTheGigPlanGroup = data.orderSummary.summaries.estimatedNextBill.myData.planGroups.find(
                (group: LevelMoveDataPlanGroup) => group.planType === 'BY_THE_GIG'
            );
        }

        if (data.orderSummary.summaries.estimatedMonthlyBill.myData.planGroups && data.orderSummary.summaries.estimatedMonthlyBill.myData.planGroups.length > 0) {
            data.monthlyByTheGigPlanGroup = data.orderSummary.summaries.estimatedMonthlyBill.myData.planGroups.find(
                (group: LevelMoveDataPlanGroup) => group.planType === 'BY_THE_GIG'
            );
        }

        if (data.orderSummary.summaries.estimatedNextBill.myData.planGroups && data.orderSummary.summaries.estimatedNextBill.myData.planGroups.length > 0) {
            data.tabletPlanGroup = data.orderSummary.summaries.estimatedNextBill.myData.planGroups.find(
                (group: LevelMoveDataPlanGroup) => group.planType === 'TABLET'
            );
        }

        if (data.orderSummary.summaries.estimatedMonthlyBill.myData.planGroups && data.orderSummary.summaries.estimatedMonthlyBill.myData.planGroups.length > 0) {
            data.monthlyTabletPlanGroup = data.orderSummary.summaries.estimatedMonthlyBill.myData.planGroups.find(
                (group: LevelMoveDataPlanGroup) => group.planType === 'TABLET'
            );
        }

        if (data.orderSummary.summaries.estimatedNextBill.myData.planGroups && data.orderSummary.summaries.estimatedNextBill.myData.planGroups.length > 0) {
            data.smartWatchPlanGroup = data.orderSummary.summaries.estimatedNextBill.myData.planGroups.find(
                (group: LevelMoveDataPlanGroup) => group.planType === 'SMART_WATCH'
            );
        }

        if (data.orderSummary.summaries.estimatedMonthlyBill.myData.planGroups && data.orderSummary.summaries.estimatedMonthlyBill.myData.planGroups.length > 0) {
            data.monthlySmartWatchPlanGroup = data.orderSummary.summaries.estimatedMonthlyBill.myData.planGroups.find(
                (group: LevelMoveDataPlanGroup) => group.planType === 'SMART_WATCH'
            );
        }

        return super.create<T>(data);
    }
}
